import {
    HAS_FIRED_LANDING_ITEMS_IMPRESSION,
    HAS_FIRED_COMPLEMENTARY_ITEMS_IMPRESSION,
} from '../actions/pdpRespSimilarItemsActions';

const initialState = {
    ecommerceImpressions: {
        hasFiredLandingItems: false,
        hasFiredSellerItems: false,
        hasFiredSimilarItems: false,
        hasFiredComplementaryItems: false,
    },
};

export function pdpRespSimilarItemsReducer(state, action) {
    switch (action.type) {
        case HAS_FIRED_LANDING_ITEMS_IMPRESSION:
            return {
                ...state,
                ecommerceImpressions: {
                    ...state.ecommerceImpressions,
                    hasFiredLandingItems: true,
                },
            };

        case HAS_FIRED_COMPLEMENTARY_ITEMS_IMPRESSION:
            return {
                ...state,
                ecommerceImpressions: {
                    ...state.ecommerceImpressions,
                    hasFiredComplementaryItems: true,
                },
            };
    }

    return state || initialState;
}
